import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

type SearchResultsHeadlineProps = {
	count: number;
	query: string;
};

const SearchResultsHeadline = ({ count, query }: SearchResultsHeadlineProps) => {
	const theme = useTheme();

	return (
		<Typography
			component="p"
			sx={{
				...theme.typography['body-xl'],
				lineHeight: '1.5rem',
				color: 'common.white',
				m: 0,
				pl: 4
			}}
		>
			<Box component="span" sx={{ fontWeight: 300 }}>
				{count} {count === 1 ? 'Ergebnis' : 'Ergebnisse'}{' '}
			</Box>
			<Box component="span" sx={{ fontWeight: 500 }}>
				&bdquo;{query}&ldquo;
			</Box>
		</Typography>
	);
};

export default SearchResultsHeadline;
